<template>
  <div>
    <section class="banner">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="banner__title">Aprenda a
              <br>controlar suas
              <br>finanças com
              <br>apenas um toque!
            </h1>
            <p>Teste GRÁTIS por uma semana!*</p>
            <p class="condition">*Após esse período, assinatura de R$5,19 por semana</p>

            <a class="btn btn-light font-weight-bold btn-lg mr-4" href="https://play.google.com/store/apps/details?id=br.com.mlearn.timfinancas" target="_blank">ANDROID</a>
            <a class="btn btn btn-light font-weight-bold btn-lg" href="https://app.timfinancas.com.br" target="_blank">VERSÃO WEB</a>

            <span>
              Envie um SMS para
              <strong>6634</strong> com a palavra
              <strong>OK</strong> e aproveite
              <br>todos os benefícios!
            </span>
          </div>
        </div>
      </div>
      <!-- container -->
    </section>
    <!-- banner -->
    <section class="call">
      <div class="container-fluid text-center">
        <h2 class="call__title">Mais de 1 milhão de pessoas já
          <br>aprenderam com o TIM finanças!
        </h2>
      </div>
    </section>
    <!-- call -->
    <section class="financas">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <h2 class="financas__title">Aprenda sobre finanças no seu smartphone</h2>

            <p>
              O
              <strong>TIM finanças</strong>
              é um guia prático, com todas as informações necessárias para que você possa manter a sua saúde financeira e profissional em dia!
            </p>

            <p
              class="mb-0"
            >Ele vai te ajudar a controlar suas finanças pessoais, fazendo com que você seja capaz de gerenciar melhor suas receitas e despesas, identificar para onde estão indo os seus gastos e ainda abrir e gerenciar sua empresa.</p>

            <p class="financas__info">Primeira semana GRÁTIS*</p>
            <span>*Após esse período, assinatura de R$5,19 por semana</span>

            <a
              class="btn btn-primary font-weight-bold btn-lg mr-4"
              href="https://play.google.com/store/apps/details?id=br.com.mlearn.timfinancas"
              target="_blank">
              ANDROID
            </a>
            <a
              class="btn btn btn-primary font-weight-bold btn-lg"
              href="https://app.timfinancas.com.br"
              target="_blank"
            >VERSÃO WEB</a>
          </div>
          <!-- col-md-6 -->
          <div class="col-md-6">
            <img src="~assets/img/app-screens.png" class="img-fluid">
          </div>
        </div>
        <!-- row -->
      </div>
      <!-- container -->
    </section>
    <!-- financas -->
    
    <!--
    <section class="boa-vista">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <h2 class="boa-vista__title">Você sabe como anda a situação do seu CPF?</h2>
            <p>Saber a situação do seu CPF é muito útil para aumentar suas chances na hora de conseguir um empréstimo e verificar caso tenha pendências.</p>
          </div>
          <div class="col-md-6">
            <img src="~assets/img/app-single-screen.png" alt class="img-fluid ml-auto">
          </div>
        </div>
      </div>
    </section>
    -->

    <!-- boa-vista -->
    <section class="duvidas">
      <div class="container">
        <div class="row">
          <div class="col-md-6 text-center">
            <img src="~assets/img/porco.png" alt class="mb-5">
          </div>
          <div class="col-md-6">
            <h2 class="duvidas__title">Possui dúvidas financeiras?</h2>
            <p>
              <strong>Aprimore seu controle financeiro!</strong>
              <br>Esclareça suas dúvidas com nossos especialistas em finanças e aprenda melhores práticas para gerenciar sua vida financeira e a da sua empresa.
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- duvidas -->
    <section class="aprender">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="aprender__title">O que você vai aprender</h2>
          </div>
        </div>
        <!-- row -->
        <div class="row">
          <div class="col-sm-6 col-md-3 aprender__single">
            <img src="~assets/img/financas.png" class="img-fluid">
            <h3>Finanças Pessoais</h3>
          </div>
          <div class="col-sm-6 col-md-3 aprender__single">
            <img src="~assets/img/investimentos.png" class="img-fluid">
            <h3>Investimentos</h3>
          </div>
          <div class="col-sm-6 col-md-3 aprender__single">
            <img src="~assets/img/negociacao.png" class="img-fluid">
            <h3>Técnicas de Negociação</h3>
          </div>
          <div class="col-sm-6 col-md-3 aprender__single">
            <img src="~assets/img/empreendedorismo.png" class="img-fluid">
            <h3>Empreendedorismo</h3>
          </div>
        </div>
      </div>
    </section>
    <!-- aprender -->
    <section class="certificao">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <h2 class="certificao__title">Certicação reconhecida</h2>
            <p>Além de ter acesso a um conteúdo de qualidade, você ainda recebe, ao final, um certificado da mLearn reconhecido pelo mercado de trabalho.</p>
          </div>
          <div class="col-md-6">
            <img src="~assets/img/abed.png" class="d-block ml-auto mr-auto mt-5">
          </div>
        </div>
      </div>
    </section>
    <!-- certificao -->
    <section class="alunos">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="alunos__title">O que dizem nossos alunos</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 alunos-single">
            <h3 class="alunos-single__title">Alice Moura</h3>
            <p class="alunos-single__text">"Adorei os cursos, fácil de usar! Super recomendo."</p>
          </div>
          <div class="col-sm-4 alunos-single">
            <h3 class="alunos-single__title">Gustavo Oliveira</h3>
            <p class="alunos-single__text">"Dicas Práticas do dia a dia!"</p>
          </div>
          <div class="col-sm-4 alunos-single">
            <h3 class="alunos-single__title">Thiago Diniz</h3>
            <p class="alunos-single__text">"Bem dinâmico e organizado, conteúdo bem objetivo!"</p>
          </div>
        </div>
      </div>
    </section>
    <!-- alunos -->
    <section id="recursos" class="features container">
      <div class="row">
        <div class="col-12">
          <h2 class="features__title">O que você pode fazer no TIM Finanças</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3 col-6 text-center">
          <img src="~assets/img/livro.png" alt class="img-fluid">
          <h3>Conteúdos em Texto</h3>
        </div>
        <div class="col-sm-3 col-6 text-center">
          <img src="~assets/img/lapis.png" alt class="img-fluid">
          <h3>Exercícios</h3>
        </div>
        <div class="col-sm-3 col-6 text-center">
          <img src="~assets/img/mic.png" alt class="img-fluid">
          <h3>Podcasts</h3>
        </div>
        <div class="col-sm-3 col-6 text-center">
          <img src="~assets/img/video.png" alt class="img-fluid">
          <h3>Vídeos</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3 col-6 text-center">
          <img src="~assets/img/wifi.png" alt class="img-fluid">
          <h3>Modo Offline</h3>
        </div>
        <div class="col-sm-3 col-6 text-center">
          <img src="~assets/img/certificado.png" alt class="img-fluid">
          <h3>Certificados</h3>
        </div>
        <div class="col-sm-3 col-6 text-center">
          <img src="~assets/img/lamp.png" alt class="img-fluid">
          <h3>Dicas</h3>
        </div>
        <div class="col-sm-3 col-6 text-center">
          <img src="~assets/img/game.png" alt class="img-fluid">
          <h3>Gamification</h3>
        </div>
      </div>
    </section>
    <!-- features -->
    <section class="dispositivos">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="dispositivos__title">Acesse o app em diversos dispositivos</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center">
            <img src="~assets/img/telas.png" alt class="img-fluid">
          </div>
        </div>
      </div>
    </section>

    <section id="assine" class="assine">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <h2 class="assine__title">Assine agora!</h2>
            <p>
              Envie um SMS para
              <strong>6634</strong> com a palavra
              <strong>OK</strong> e aproveite todos os benefícios!
            </p>

            <div class="assine__info">
              <p>Ou baixe o app TIM Finanças</p>
              <a class="btn btn-light font-weight-bold btn-lg mr-4" href="https://play.google.com/store/apps/details?id=br.com.mlearn.timfinancas" target="_blank">ANDROID</a>
              <a
                class="btn btn btn-light font-weight-bold btn-lg"
                href="https://app.timfinancas.com.br"
                target="_blank"
              >VERSÃO WEB</a>
              <span>Primeira semana grátis. Após, assinatura de R$5,19 por semana.</span>
            </div>
          </div>
          <div class="col-sm-6">
            <img
              src="~assets/img/app.png"
              alt
              class="img-fluid mr-sm-0 mt-5 m-auto mt-sm-0 d-block"
            >
          </div>
        </div>
      </div>
    </section>
    <!-- assine -->
  </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>

<style lang='scss'>
@import "~assets/scss/globals.scss";
.banner {
  min-height: 565.5px;
  width: 100%;
  background: url("~assets/img/banner.png") center no-repeat;
  background-size: cover;
  padding-top: 65px;
  padding-bottom: 30px;

  &__title {
    line-height: normal;
    @include font-size(48);
    color: #ffffff;
    margin-bottom: 71px;
  }

  p {
    @include font-size(24);
    color: #ffffff;
    margin-top: 14px;
    margin-bottom: 0px;
  }

  p.condition {
    @include font-size(14);
    margin-top: 0px;
    margin-bottom: 16px;
  }

  a,
  a:hover {
    color: #0190cc;
  }

  span {
    @include font-size(16);
    display: block;
    margin-top: 12px;
  }
}

.call {
  min-height: 215px;
  width: 100%;
  padding-top: 57px;
  padding-bottom: 70px;
  background: url("~assets/img/money_bg.png") center no-repeat;
  background-size: cover;

  &__title {
    margin: 0;
    font-size: 2.7rem;
    color: #ffffff;
  }
}

.financas {
  color: #343434;
  padding-top: 52px;
  padding-bottom: 59px;

  &__title {
    @include font-size(40);
    font-weight: bold;
    color: #003c63;
    margin-bottom: 27px;
  }

  p {
    @include font-size(18);
    strong {
      color: #003c63;
    }
  }

  img {
    margin-top: 35px;
    display: block;
    margin-left: auto;
  }

  &__info {
    @include font-size(20);
    color: #343434;
    margin-top: 47px;
    margin-bottom: 0;
  }

  span {
    color: #626262;
    @include font-size(16);
    display: block;
    margin-bottom: 13px;
  }
}

.boa-vista {
  background-color: #74c2e5;
  padding-top: 52px;
  padding-bottom: 43px;
  border-bottom: solid 1px white;

  &__title {
    color: #003c63;
    @include font-size(40);
    font-weight: bold;
    margin-bottom: 10px;
  }
  p {
    line-height: 30px;
    @include font-size(20);
    color: #343434;
  }

  img {
    margin-top: 37px;
  }
}

.duvidas {
  background-color: #74c2e5;
  padding-top: 63px;
  padding-bottom: 50px;

  &__title {
    color: #003c63;
    @include font-size(40);
    font-weight: bold;
    margin-bottom: 24px;
  }

  p {
    line-height: 30px;
    @include font-size(20);
    color: #343434;
    strong {
      @include font-size(24);
    }
  }
}

.aprender {
  padding-top: 60px;
  padding-bottom: 60px;
  border-bottom: 1px solid #74c2e5;

  &__title {
    color: #003c63;
    @include font-size(40);
    font-weight: bold;
    margin-bottom: 45px;
  }

  &__single {
    text-align: center;

    h3 {
      @include font-size(20);
      color: #343434;
      margin-bottom: 40px;
    }
  }
}

.certificao {
  padding-top: 52px;
  padding-bottom: 66px;

  &__title {
    color: #003c63;
    @include font-size(40);
    font-weight: bold;
    margin-bottom: 24px;
  }
  p {
    line-height: 30px;
    @include font-size(20);
    color: #343434;
    margin-bottom: 30px;
  }

  img {
    margin-top: 10px;
  }
}

.alunos {
  background: #74c2e5;
  padding-top: 62px;
  padding-bottom: 62px;

  &__title {
    color: #003c63;
    @include font-size(40);
    margin-bottom: 41px;
    font-weight: bold;
  }

  &-single {
    color: #343434;
    @include font-size(20);
    text-align: center;

    &__title {
      font-weight: bold;
      @include font-size(20);
    }

    &__text {
      margin-bottom: 40px;
    }
  }
}

.features {
  padding-top: 63px;
  padding-bottom: 44px;

  &__title {
    color: #003c63;
    @include font-size(40);
    margin-bottom: 41px;
    font-weight: bold;
  }

  img {
    margin-bottom: 18px;
  }

  h3 {
    @include font-size(22);
    color: #343434;
    font-weight: bold;
  }
  .col-sm-3 {
    margin-bottom: 56px;
  }
}

.dispositivos {
  border-top: 1px solid #74c2e5;
  padding-top: 63px;
  padding-bottom: 63px;

  &__title {
    color: #003c63;
    @include font-size(40);
    margin-bottom: 41px;
    font-weight: bold;
  }
}

.assine {
  padding-top: 50px;
  padding-bottom: 50px;
  background: #74c2e5;
  @include font-size(18);
  color: #343434;

  &__title {
    @include font-size(40);
    margin-bottom: 12px;
    font-weight: bold;
    color: #003c63;
  }
  &__info {
    margin-top: 50px;

    a {
      color: #009cde !important;
    }

    span {
      display: block;
      line-height: 21px;
      @include font-size(16);
      color: #343434;
      margin-top: 7px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?34938d53